import { Component, OnInit, ViewChild } from '@angular/core';
import { PersonPortalState } from '@app/models/person-portal-state';
import { LocalStorageUtilities } from '@app/utilities/local-storage-utilities';
import { UppercaseFirstLetterPipe } from '@app/pipes/uppercase-first-letter.pipe';
import { MxposTrade } from '@app/models/mxpostrade';
import { MatTable } from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ValidationRequest } from '@app/models/validation-request';
import { AuthorizationService } from '@app/services/authorization.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-depository-confirmation',
  templateUrl: './depository-confirmation.component.html',
  styleUrls: ['./depository-confirmation.component.css'],
  providers: [UppercaseFirstLetterPipe, DatePipe]
})
export class DepositoryConfirmationComponent implements OnInit {

  public personPortalState: PersonPortalState;

  public mxpostrades: MxposTrade[];
  public validationRequests: ValidationRequest[];

  public depository: string;
  public transferredCount: number = 0;
  public validationRequestCount: number = 0;
  public disableRequestButton: boolean = true;

  //public transferredDataSource = new MatTableDataSource<MxposTrade>(this.mxpostrades);
  public transferredDataSource;
  //public validationRequestDataSource = new MatTableDataSource<ValidationRequest>(this.validationRequests);
  public validationRequestDataSource;
  public transferredColumns: string[] = ['tradeNum', 'tradeDate', 'description', 'unitBal'];
  public validationRequestColumns: string[] = ['queuedDate', 'description', 'processedDate'];

  @ViewChild("requestTable", { static: true })
  requestTable: MatTable<ValidationRequest>;
  @ViewChild("transferredPaginator", { static: true })
  transferredPaginator: MatPaginator;
  @ViewChild("transferredSort", { static: true })
  transferredSort: MatSort;
  @ViewChild("validationRequestPaginator", { static: true })
  validationRequestPaginator: MatPaginator;
  @ViewChild("validationRequestSort", { static: true })
  validationRequestSort: MatSort;

  constructor(private uppercaseFirstLetterPipe: UppercaseFirstLetterPipe,
    private authorizationService: AuthorizationService) { }

  ngOnInit() {
    this.initUI();
  }

  //
  // Saves the validation request so it can be processed during nightly processing.
  //
  // Info: The datasource provides the data array to the table via an Observable. That Observable emits when new data is set.
  //       In your example, that stream will not emit new data to the table since you are not providing a new data array.
  //       Instead, take the data and perform on operation on it, and then provide it to the datasource so it knows to emit a
  //       new value to the table.
  public onRequestConfirmationClick(): void {

    let validationRequest: ValidationRequest = new ValidationRequest();

    validationRequest.keyP = this.personPortalState.mxna.co + this.personPortalState.acctNum;
    validationRequest.co = this.personPortalState.mxna.co;
    validationRequest.account = this.personPortalState.mxna.account;
    validationRequest.description = "Your request has been queued for processing.";
    validationRequest.timestamp = new Date();
    this.authorizationService.saveValidationRequest(validationRequest).subscribe(v => {
      const data: ValidationRequest[] = this.validationRequestDataSource.data;
      data.push(validationRequest);
      this.validationRequestDataSource.data = data;
      this.validationRequestCount = this.validationRequests.length;
    }), error => {
      console.log(`Verification request: ${error}`);
    };
    this.disableRequestButton = true;
  }

  public initUI(): void {
    // Update state.
    this.personPortalState = LocalStorageUtilities.getPersonPortalState();
    // Custodian name.
    if (this.personPortalState.mxna.mxlocation !== undefined && this.personPortalState.mxna.mxlocation !== null) {
      this.depository = this.uppercaseFirstLetterPipe.transform(this.personPortalState.mxna.mxlocation.bankNameLine1);
    }
    // Transfered positions.  
    this.mxpostrades = [];
    this.transferredDataSource = new MatTableDataSource<MxposTrade>(this.mxpostrades);
    this.personPortalState.mxna.mxPosTrade.forEach((mpt) => {
      if (mpt.unitBal > 0 && mpt.transferUnits > 0) {
        this.mxpostrades.push(mpt);
      }
    });
    // Transfered positions count.
    this.transferredCount = this.mxpostrades.length;
    // Processed Verification requests.
    this.validationRequests = [];
    this.validationRequestDataSource = new MatTableDataSource<ValidationRequest>(this.validationRequests);
    this.personPortalState.mxna.validationRequest.forEach(vr => {
      this.validationRequests.push(vr);
    });
    // Verification request count.
    this.validationRequestCount = this.validationRequests.length;
    // Table paginator.
    this.transferredDataSource.paginator = this.transferredPaginator;
    this.validationRequestDataSource.paginator = this.validationRequestPaginator;
    // Force table to sort decendingly on tradeDate. 
    this.validationRequestSort.sort({ id: 'effectDate', start: 'desc', disableClear: false });
    // Disable the request button if the user has already made a request today.
    if (this.transferredCount > 0) {
      let todayRequestCount: number = this.personPortalState.mxna.validationRequest.filter((validationRequest: ValidationRequest) => {
        // There may be a better way of handling this, but for now, it does the job.     
        let requestDateNoTime: Date = new Date(validationRequest.timestamp);
        // Remove time from date.  
        let newDateNoTime: Date = new Date(requestDateNoTime.toDateString());
        let today: Date = new Date();
        // Remove time from date.
        let todayNoTime: Date = new Date(today.toDateString());              
        return newDateNoTime.getTime() === todayNoTime.getTime();
      }).length;
      this.disableRequestButton = todayRequestCount !== 0;
    }
  }

  /**
   * Called from the "Main" module when the selected account changes.
   */
  public refreshUI(): void {
    this.initUI();
  }

}
